<ion-content class="garment-listing">
    <app-header [isParentPage]="false" [title]="'Garment Listing Report'"></app-header>
    <div class="page-loader" style="padding-top:15%;" *ngIf="!loaded">
        <ion-spinner></ion-spinner>
    </div>
    <ng-container #content>
        <ion-grid>
            <ion-row class="filter-row">
                <ion-grid>
                    <ion-row class="ion-align-items-start ion-wrap">
                        <ion-col  size="12"  [sizeMd]="authService.user?.isCostCenterUser? 4:5" *ngIf="!seachByGarmentCode" >
                            <div>
                                <ion-input type="text" [(ngModel)]="lastName" class="ion-text-left color-light" placeholder="{{authService.user?.isCostCenterUser ? 'Enter part of last name, stop code or leave blank for all' : 'Enter part of last name or leave blank for all'}}"   (keydown.enter)="onEnterKey($event)"></ion-input>
                            </div>
                        </ion-col>
                         <ion-col size="12" size-md="0.8" *ngIf=" !seachByGarmentCode && !authService.user?.isCostCenterUser"  style="margin-right:10px">
                             <ion-button  color="gallaghergreen" class="btn-box-shadow" (click)="getDataByLastName()"><span>Show</span></ion-button>
                         </ion-col>
                        <ion-col size="12" size-md="3" *ngIf="authService.user?.isCostCenterUser && !seachByGarmentCode">
                            <div>
                                <ng-select style="margin-right:10px" placeholder="Select Cost Center" class="select" (change)="changeCostCenter($event)"   [(ngModel)]="selectedCostCenter"  (keydown.enter)="onEnterKey($event)">
                                    <ng-option *ngFor="let costCenter of loginDepts" value="{{costCenter.departmentCode}}">{{costCenter.departmentCode}}</ng-option>
                                </ng-select>
                                <ion-button color="gallaghergreen" class="btn-box-shadow" (click)="getDataCostCenter()"><span>Show</span></ion-button>
                            </div> 
                        </ion-col>
                        <ion-col  *ngIf="!seachByGarmentCode" size="12" size-md="4" >
                             <ion-row>
                              <a   style="color:white; text-decoration: underline; cursor: pointer;" class="text-link" (click)="showGarmentSearchBox()"> Search by Garment Code </a>
                            </ion-row>
                        </ion-col>
                        <ion-col *ngIf="seachByGarmentCode" size="12" size-md="6">
                            <div>
                                <ion-input type="text" [(ngModel)]="garmentCode" placeholder="Enter Garment Code or RFID" class="ion-text-left color-light" (keydown.enter)="onEnterKeyGarCode($event)"></ion-input>
                                <ion-button color="gallaghergreen" class="btn-box-shadow" style="margin-left:10px" (click)="getDataByGarmentCode()"><span>Show</span></ion-button>
                            </div>
                        </ion-col>
                         <ion-col  *ngIf="seachByGarmentCode" size="12" size-md="4" style="padding-top:25px;">
                             <div>
                              <a  style="color:white; text-decoration: underline; cursor: pointer;"  (click)="showSearchBox()"> Search by Name </a>
                            </div>
                        </ion-col>
                    </ion-row>
                 
                </ion-grid>

            </ion-row>
            <ion-row justify-content-center>
                <ion-col size="12" class="center-text">
                    <p style="margin-bottom: 1px;">Click for printer friendly version.</p>
                </ion-col>
             </ion-row>
            <ion-row >
                <div *ngIf="!authService.user?.isWearer && !authService.user?.isCostCenterUser" class="ion-padding table-container" >
                    <app-report-table [mode]="'gl'" (paging)="setPage($event)" [pageSize]="pageSize" [pageNumber]="currPage" [rows]="rows" [currentRoute]="currentRoute" [totalElements]="totalElements" [scrollbarV]="true" (stopCodeClicked)="onStopCodeFilter($event)"
                    [pageType]="!authService.user?.isCostCenterUser ? 'garmentListing' : ''" ></app-report-table>
                </div>
                <div *ngIf="authService.user?.isCostCenterUser" class="ion-padding table-container">
                    <app-cost-center-report-table  [mode]="'gl'" (paging)="setPage($event)" [pageSize]="pageSize" [pageNumber]="currPage" [rows]="rows" [currentRoute]="currentRoute" [totalElements]="totalElements" (stopCodeClicked)="onStopCodeFilter($event)" (costCenterClicked)="onCostCenterFilter($event)" [pageType]="authService.user?.isCostCenterUser ? 'garmentListing' : ''" ></app-cost-center-report-table>
                </div>
            </ion-row>
        </ion-grid>
    </ng-container>
</ion-content>
